<template>
	<ModalComponent ref="modalRef" :isHeader="false" :isFooter="false" :is-background-transparent="true">
		<div class="partial-filled text-base bg-grey-4 text-white text-center rounded p-4">
			<div class="text-1.5xl font-bold mb-3">
				Partial Fill (Partial Execution)
			</div>

			<div class="mb-3">
				A condition where an order is partially executed from the total amount of physical gold in a single order (buy
				or sell). Since JFXGold X operates on a multilateral scheme, this only occurs when there are not enough buyers
				or sellers to fulfill the entire order, resulting in only a partial of the order being executed.
			</div>

			<div v-if="$store.getters.paymentMethod == 'rped'" class="mb-6">
				If no match is found between buyers and sellers within more than 2 days (market days) for a market order, the
				remaining portion of the order will be cancelled by the system, resulting in a Cancelled order status.
			</div>

			<div v-else class="mb-6">
				Because each Partial Fill is an independent execution process,
				<span class="text-gold">
					an admin fee of Rp2,500 will be charged for each successfully matched Partial Fill.
				</span>
			</div>

			<div>
				<button class="btn c-btn-theme w-full" @click="closePartialFilledExplained()">OK</button>
			</div>
		</div>
	</ModalComponent>
</template>

<script>
import ModalComponent from './ModalComponent.vue'

export default {
	name: 'PartialFilledExplained',

	components: {
		ModalComponent
	},

	props: {
	},

	data() {
		return {
		}
	},

	methods: {
		openPartialFilledExplained() {
			this.$refs.modalRef.openModal()
		},

		closePartialFilledExplained() {
			this.$refs.modalRef.closeModal()
		},
	},
}
</script>

<style scoped>
.partial-filled {
	width: 29.6875rem;
	max-width: calc(100% - 2.5rem);
}
</style>